import { Search, BarChart3, FileSpreadsheet, PencilRuler, HardHat, TrendingUp, Building2, Layers, Home, Briefcase, KeyRound, Handshake } from "lucide-react";

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/chi-siamo", label: "Chi Siamo", compactHidden: true },
  { to: "/cosa-facciamo", label: "Cosa Facciamo", compactHidden: true },
  { to: "/progetti", label: "Progetti" },
  { to: "/investitori", label: "Investitori" },
  { to: "/operazioni", label: "Operazioni Aperte" },
  { to: "/la-rotta-del-valore", label: "La Rotta del Valore" },
  { to: "/proponi-immobile", label: "Proponi un Immobile", compactHidden: true },
  { to: "/contatti", label: "Contatti" },
];

export const HERO = {
  eyebrow: "Real Estate Development & Investment",
  headline: "Trasformiamo immobili in opportunità di valore.",
  text1: "Home Haven sviluppa operazioni immobiliari attraverso acquisizione, riqualificazione, frazionamento e valorizzazione degli asset.",
  text2: "Dalla ricerca dell'opportunità alla progettazione, dalla trasformazione dell'immobile alla vendita o messa a reddito, sviluppiamo ogni progetto con un unico obiettivo: creare valore.",
  payoff: "Creiamo valore trasformando gli spazi.",
};

export const ABOUT = {
  title: "Real Estate. Visione. Valore.",
  paragraphs: [
    "Home Haven nasce con una visione precisa: individuare il potenziale nascosto negli immobili e trasformarlo in valore.",
    "Analizziamo il mercato, selezioniamo opportunità immobiliari e sviluppiamo progetti di riqualificazione capaci di migliorare la qualità, la funzionalità e il posizionamento dell'asset.",
    "Ogni operazione nasce dall'analisi dei numeri e prosegue attraverso progettazione, trasformazione e definizione della migliore strategia di valorizzazione.",
  ],
};

export const PILLARS = [
  { n: "01", title: "Analizziamo", text: "Individuiamo immobili e opportunità con potenziale di valorizzazione." },
  { n: "02", title: "Trasformiamo", text: "Progettiamo e coordiniamo interventi di riqualificazione e frazionamento." },
  { n: "03", title: "Valorizziamo", text: "Definiamo la migliore strategia tra vendita, locazione e sviluppo dell'asset." },
];

export const SERVICES = [
  { icon: Building2, title: "Acquisizione Immobiliare", text: "Ricerca e selezione di immobili con potenziale di trasformazione e valorizzazione." },
  { icon: PencilRuler, title: "Riqualificazione", text: "Riprogettazione degli spazi e interventi finalizzati ad aumentare qualità e valore dell'immobile." },
  { icon: Layers, title: "Frazionamento", text: "Studio e sviluppo di operazioni che consentano di ottimizzare superfici e destinazioni degli immobili." },
  { icon: Briefcase, title: "Property Development", text: "Gestione dell'intero processo di sviluppo, dalla valutazione iniziale alla realizzazione del progetto." },
  { icon: KeyRound, title: "Immobili a Reddito", text: "Sviluppo di immobili destinati alla locazione tradizionale, transitoria o short rent." },
  { icon: Handshake, title: "Real Estate Investment", text: "Strutturazione e sviluppo di specifiche opportunità immobiliari anche in collaborazione con investitori." },
];

export const METHOD = [
  { n: "01", title: "Scouting", text: "Ricerca dell'opportunità immobiliare.", icon: Search },
  { n: "02", title: "Analisi", text: "Studio dell'immobile, del mercato, dei costi e delle potenzialità.", icon: BarChart3 },
  { n: "03", title: "Business Plan", text: "Definizione dell'investimento, dei costi di trasformazione e della strategia di valorizzazione.", icon: FileSpreadsheet },
  { n: "04", title: "Progettazione", text: "Ottimizzazione degli spazi e definizione dell'intervento.", icon: PencilRuler },
  { n: "05", title: "Realizzazione", text: "Coordinamento della riqualificazione dell'immobile.", icon: HardHat },
  { n: "06", title: "Valorizzazione", text: "Vendita, locazione o sviluppo della strategia di uscita prevista.", icon: TrendingUp },
];

export const METHOD_QUOTE = "Ogni progetto parte dai numeri. Ogni trasformazione nasce da una visione.";

export const INVEST = {
  title: "Investire nella trasformazione immobiliare",
  paragraphs: [
    "Home Haven seleziona e sviluppa opportunità immobiliari caratterizzate da un concreto potenziale di valorizzazione.",
    "Per specifiche operazioni possiamo collaborare con investitori interessati a partecipare allo sviluppo di singoli progetti immobiliari.",
    "Ogni progetto viene analizzato attraverso un business plan che considera investimento, costi di trasformazione, scenario di mercato, strategia operativa e possibile exit.",
  ],
  flow: ["Opportunità", "Analisi", "Investimento", "Trasformazione", "Valorizzazione", "Exit"],
};

export const PROPOSE = {
  headline: "Hai un immobile con potenziale? Parliamone.",
  paragraphs: [
    "Home Haven valuta opportunità immobiliari da acquisire, riqualificare o sviluppare.",
    "Siamo interessati a immobili da ristrutturare, immobili frazionabili e proprietà con potenziale di valorizzazione.",
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  exterior: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  interior: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  living: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  detail1: "https://images.unsplash.com/photo-1569258592171-357ea26da4df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  detail2: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
};
